export const AVATAR_COLORS = [
  '#e55934',
  '#ed1b24',
  '#1a936f',
  '#114b5f',
  '#bc8034',

  '#224b5f',
  '#357ded',
  '#30c5ff',
  '#ad8a64',
  '#b24c63',
];
